const prod = {
  url: {
    API_URL: 'https://api.codice.com.co/',
    IMG_PATH: 'https://codice-assets.s3.us-east-2.amazonaws.com',
    FRONT_URL: 'http://codiceweb.s3-website.us-east-2.amazonaws.com/',
    WEB: 'https://codice.com.co/',
  },
  idRestaurantes: '5fbffe917c7b691dd0e9c4ee',
};


const appMode = (() => { try { return localStorage.getItem('APP_MODE'); } catch { return null; } })();
const dev = {
  url: {
    API_URL: appMode === 'development' ? 'http://localhost:4000/' : 'https://api.codice.com.co/',
    FRONT_URL: 'http://localhost:3000/#/',
    IMG_PATH: 'https://codice-assets.s3.us-east-2.amazonaws.com',
    WEB: 'https://codice.com.co',
  },
  idRestaurantes: appMode === 'dev' ? '5fbf18b9ba3c0e146853bb90' : '5fbffe917c7b691dd0e9c4ee'
};

export default {
  siteName: 'CÓDICE',
  siteIcon: 'logo.svg',
  footerText: `CÓDICE SAS @ ${new Date().getFullYear()}`,
  enableAnimatedRoute: false,
  siteUrl: process.env.NODE_ENV === 'development' ? dev.url : prod.url,
  idRestaurantes: process.env.NODE_ENV === 'development' ? dev.idRestaurantes : prod.idRestaurantes,
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};

